import type { CentraSelectionItem, ICentraSelectionProduct } from '../../interfaces';
import translate from '../../translations';
import { getBaseUrl } from '../utils';

export const getItemName = (item: CentraSelectionItem, language: string) => {
    return `${translate(language, item.product.gender_selection_gender)} ${item.size} ${translate(
        language,
        item.product.color_swatch.code
    )} ${item.product.name}`;
};

export const selectionItemToKlaviyoItem = (item: CentraSelectionItem, language: string) => {
    const baseUrl = getBaseUrl();

    return {
        ProductID: item.product.centraProduct,
        ProductName: getItemName(item, language),
        SKU: item.product.sku,
        Categories: 'categoryName' in item.product ? item.product?.categoryName : [],
        ImageURL: item.product?.media?.['standard']?.[0],
        URL: `${baseUrl}/en/shop/${item.product?.uri}`,
        Brand: 'Northern Playground',
        Price: item.priceEach,
        ItemPrice: item.priceEachAsNumber,
        Quantity: item.quantity,
        RowTotal: item.priceEachAsNumber,
        ProductCategories: item.product.collectionName,
    };
};

export const selectionItemProductToKlaviyoItem = (
    item: ICentraSelectionProduct,
    language: string
) => {
    const baseUrl = getBaseUrl();

    return {
        ProductID: item.centraProduct,
        ProductName: getItemName(
            {
                product: item,
            } as CentraSelectionItem,
            language
        ),
        SKU: item.sku,
        Categories: 'categoryName' in item ? item?.categoryName : [],
        ImageURL: item?.media?.['standard']?.[0],
        URL: `${baseUrl}/en/shop/${item?.uri}`,
        Brand: 'Northern Playground',
        Price: item.price,
        ItemPrice: item.priceAsNumber,
        Quantity: 1,
        RowTotal: item.priceAsNumber,
        ProductCategories: item.collectionName,
    };
};
